import { Overlay, OverlayConfig } from '@angular/cdk/overlay';
import { AsyncPipe } from '@angular/common';
import { Component, HostBinding, inject, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from '@bcef/ia-components/buttons';
import { InputComponent } from '@bcef/ia-components/input';
import { ListboxModule } from '@bcef/ia-components/listbox';
import { PanelModule } from '@bcef/ia-components/panel';
import { RadioButtonModule } from '@bcef/ia-components/radio-button';
import { DataLayered } from '@difa/ia-data-layer';
import { TranslateModule } from '@ngx-translate/core';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';

import { Country } from '@features/succession/enums';
import { SuccessionFacade } from '@features/succession/succession.facade';
import { BlockCopyPasteDirective } from '@shared/directives/block-copy-past.directive';
import { InvalidControlScrollDirective } from '@shared/directives/invalid-control-scroll.directive';

import { ReporterInformationFacade } from './reporter-information.facade';

@DataLayered('dataLayer.reporterInformation')
@Component({
  selector: 'ia-succession-reporter-information',
  templateUrl: './reporter-information.component.html',
  imports: [
    AsyncPipe,
    ButtonModule,
    InputComponent,
    ListboxModule,
    NgxMaskDirective,
    PanelModule,
    RadioButtonModule,
    ReactiveFormsModule,
    TranslateModule,

    BlockCopyPasteDirective,
    InvalidControlScrollDirective,
  ],
  standalone: true,
  providers: [provideNgxMask()],
})
export class ReporterInformationComponent implements OnInit {
  @HostBinding('class') public classAttribute = 'tw-flex tw-flex-col tw-mb-4 sm:tw-mx-24';

  protected readonly reporterInformationFacade = inject(ReporterInformationFacade);

  protected readonly successionFacade = inject(SuccessionFacade);

  public countryFrance = Country.FRANCE;

  protected listBoxOverlayConfig: OverlayConfig = {
    scrollStrategy: inject(Overlay).scrollStrategies.close(),
  };

  public ngOnInit(): void {
    this.reporterInformationFacade.email.valueChanges.subscribe(() => {
      this.reporterInformationFacade.emailConfirmation.updateValueAndValidity({ onlySelf: true });
    });
  }
}
